export default __webpack_public_path__ + "static/media/miguel-lopes-2.3fa56c79.jpg";